import { jsxs as o, jsx as e, Fragment as s } from "react/jsx-runtime";
import c from "classnames";
import i from "styled-components";
import m from "../Icons/VicServiceLogo.js";
import { VisuallyHidden as f } from "../VisuallyHidden/VisuallyHidden.js";
import n from "../../utils/colors.js";
import { device as a } from "../../utils/device.js";
const g = i.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  height: 60px;
`, h = i.a`
  width: 129px;
  height: 60px;
  object-fit: contain;
`, x = i.div`
  content: '';
  transform: rotate(-45deg);
  height: 44.3px;
  transform: skewX(-24deg);
  margin-left: 22px;
  border: solid 1px ${n.logoOrange};

  @media ${a.isMobile} {
    display: none !important;
  }
`, w = i.div`
  max-width: 170px;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  align-self: center;
  color: ${n.blueGrey75};
  font-size: 0.87rem;
  line-height: 14px;
  text-align: left;
  padding-left: 20px;
  font-weight: 500;
  margin-top: 4px;

  @media ${a.isMobile} {
    display: none !important;
  }
`, $ = ({
  text: r,
  href: l = "https://www.service.vic.gov.au",
  fill: d,
  onClick: p = () => {
  },
  className: t = ""
}) => /* @__PURE__ */ o(g, { className: c({ [t]: !!t }), children: [
  /* @__PURE__ */ o(h, { target: "_self", href: l, onClick: p, children: [
    /* @__PURE__ */ e(f, { children: "Go to the Service Victoria home page" }),
    /* @__PURE__ */ e(m, { fill: d })
  ] }),
  r && /* @__PURE__ */ o(s, { children: [
    /* @__PURE__ */ e(x, {}),
    /* @__PURE__ */ e(w, { children: r })
  ] })
] });
export {
  $ as Logo,
  $ as default
};
